// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__1Yk66","boxTitle":"Qualiphy_boxTitle__uEZ5w","box":"Qualiphy_box__E4ab1","toggleWrap":"Qualiphy_toggleWrap__2E0Vv"};